import { Button } from "@sellar-io/components";
import { ReactElement, useState } from "react";
import { useIntegrationDelete } from "../../../hooks/api/v2/integration/useIntegrationDelete";
import { IntegrationDeactivationModal } from "./IntegrationDeactivationModal";

export const SellarIntegrationSettingsDelete = ({
  setMessage,
  integrationId,
}: {
  setMessage: (message: string) => void;
  integrationId: number;
}): ReactElement => {
  const [isActive, setIsActive] = useState(false);
  const deleteIntegrationMutation = useIntegrationDelete(integrationId);

  const deactivateIntegration = async () => {
    deleteIntegrationMutation.mutate(undefined, {
      onError: () =>
        setMessage(
          "There was a problem deactivating your API keys. Please contact support",
        ),
      onSettled: () => setIsActive(false),
    });
  };

  return (
    <>
      <Button color={"inverse-red"} onClick={() => setIsActive(true)}>
        Deactivate API Key
      </Button>
      <IntegrationDeactivationModal
        active={isActive}
        onDismiss={() => setIsActive(false)}
        onSubmit={deactivateIntegration}
        loading={deleteIntegrationMutation.isPending}
        title={"Deactivate your API key?"}
        subtitle={
          "Are you sure? Deactivating your API key will prevent data from being shared with apps you’re connected to."
        }
      />
    </>
  );
};
